import React from 'react';

import Votes from 'components/Votes';

class InviteDate extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      voters: this.props.voters
    };

    this.formatDay = this.formatDay.bind(this);
    this.formatTime = this.formatTime.bind(this);
  }

  formatDate(date) {
    let when = new Date(date);
    const day = when.toLocaleDateString('en', {day: 'numeric'});
    const month = when.toLocaleDateString('en', {month: 'short'}).toUpperCase();

    return(
      <React.Fragment>
        <div>{day}</div>
        <small>{month}</small>
      </React.Fragment>
    );
  }

  formatDay(date) {
    let when = new Date(date);
    return when.toLocaleDateString('en', {weekday: 'long'});
  }

  formatTime(time) {
    return time;
  }

  render() {
    return (
      <React.Fragment>
      <div className="date-image u-pull-left">
        {this.formatDate(this.props.date.day)}
      </div>

      <table className="date">
        <tbody>
          <tr>
            <th colSpan={this.props.date.votes.length}>
              {this.formatDay(this.props.date.day)}
            </th>
            <th>
              {this.formatTime(this.props.date.time)}
            </th>
          </tr>
          <tr>
            <Votes votes={this.props.date.votes} voters={this.state.voters} />
          </tr>
        </tbody>
      </table>
      </React.Fragment>
    );
  }
}

export default InviteDate;
